import React from "react";
import styles from "./TileBody.module.css";

export default function TileBody({ children, className = "" }) {
	return <main className={`${styles.tileBody} ${className}`}>{children}</main>;
}
